__turbopack_context__.v({
  "navigation--not-authenticated": "kyW8mq_navigation--not-authenticated",
  "navigation-wrapper": "kyW8mq_navigation-wrapper",
  "navigation__authentication": "kyW8mq_navigation__authentication",
  "navigation__list": "kyW8mq_navigation__list",
  "navigation__list-item-icon": "kyW8mq_navigation__list-item-icon",
  "navigation__list-item-icon--expanded": "kyW8mq_navigation__list-item-icon--expanded",
  "navigation__list-item-link": "kyW8mq_navigation__list-item-link",
  "navigation__list-item-link--active": "kyW8mq_navigation__list-item-link--active",
  "navigation__list-item-link--expanded": "kyW8mq_navigation__list-item-link--expanded",
  "navigation__list-item-link__icon": "kyW8mq_navigation__list-item-link__icon",
  "navigation__list-secondary": "kyW8mq_navigation__list-secondary",
});
